export const LISTING_TYPE = {
  ALL: 'all',
  ORDER: 'order'
}

export const LISTING_TYPE_MAP = {
  [LISTING_TYPE.ALL]: '全部賣場',
  [LISTING_TYPE.ORDER]: '指定賣場'
}

export const LISTING_TYPE_OPTIONS = [
  {
    label: LISTING_TYPE_MAP[LISTING_TYPE.ALL],
    value: LISTING_TYPE.ALL
  },
  {
    label: LISTING_TYPE_MAP[LISTING_TYPE.ORDER],
    value: LISTING_TYPE.ORDER
  }
]
